export default __webpack_public_path__ + "static/media/check-circle.639ea4df.svg";